import { IGridColumnsSettings } from 'api/portalUser/types';
import { IAllPageFilters } from 'utils/types';

import { PRESET_IGNORE_FIELDS } from '../utils/constants';
import { ISearchFilters } from '../utils/types';

export const REDIRECTED_PRESET = 'redirectedPreset';

interface IGetFiltersToSaveProps {
  columns?: IGridColumnsSettings;
  ignoreList?: string[];
  search: IAllPageFilters['search'];
}

export const getFiltersToSave = ({
  columns,
  ignoreList,
  search,
}: IGetFiltersToSaveProps) => {
  const appliedFilters: ISearchFilters = {};

  for (const filterKey in search) {
    const filter = search[filterKey];

    const isFilterKeyVisible = columns ? !!columns?.[filterKey]?.visible : true;
    const isIgnored = ignoreList?.includes(filterKey);

    if (
      filter?.value !== undefined &&
      filter.value !== '' &&
      isFilterKeyVisible &&
      !isIgnored
    ) {
      appliedFilters[filterKey] = filter;
    }
  }

  const {
    [PRESET_IGNORE_FIELDS.CREATED]: _created,
    [PRESET_IGNORE_FIELDS.CREATION_DATE]: _creationDate,
    [PRESET_IGNORE_FIELDS.REGISTRATION_DATE]: _registrationDate,
    ...filtersToSave
  } = appliedFilters;

  return filtersToSave;
};
